import { Box, Text, Stack } from "@chakra-ui/layout";
import BaccountA from "assets/icons/b-account-a.svg";
import Baccount from "assets/icons/b-account.svg";
import BhomeA from "assets/icons/b-home-a.svg";
import Bhome from "assets/icons/b-home.svg";
import Bp2pA from "assets/icons/b-p2p-a.svg";
import Bp2p from "assets/icons/b-p2p.svg";
import BswapA from "assets/icons/b-swap-a.svg";
import Bswap from "assets/icons/b-swap.svg";
import BwalletA from "assets/icons/b-wallet-a.svg";
import Bwallet from "assets/icons/b-wallet.svg";
import { ReactComponent as EarnWallet } from "assets/svg/earn.svg";
import { ReactComponent as Logout } from "assets/icons/log-out.svg";
// assets
import Logo from "assets/logos/logo-1.svg";
import Apple from "assets/svg/appstore.svg";
import Google from "assets/svg/googleplay.svg";
// import { isProd } from "config/constant";
import { Link } from "react-router-dom";

import { BsFillCreditCard2BackFill } from "react-icons/bs";
//css
import "./css/sidemenu.css";
import { useDisclosure } from "@chakra-ui/react";
import Confirm from "components/Modals/p2p/Confirmation";

export const EmptyDiv = ({ children, ...props }) => {
  return <div {...props}>{children && children}</div>;
};

// const disableP2P = isProd ? true : false;
const disableP2P = false;
const disableSwap = false;

const Sidemenu = ({ currentPage, logoutUser }) => {
  const WrappedP2PLink = disableP2P ? EmptyDiv : Link;

  const { isOpen, onClose, onOpen: openLogout } = useDisclosure();

  const handleLogout = () => {
    console.log("logout was clicked on");
    logoutUser && logoutUser();
    logoutUser && (window.location = "/");
  };

  return (
    <div>
      <section className="sidemenu">
        <div className="sidemenu-container">
          <div className="sidemenu-content">
            <div className="sidemenu-logo">
              <Link to="/dashboard/home">
                <img src={Logo} alt="logo" />
              </Link>
            </div>
            <div className="sidemenu-nav">
              {currentPage !== "Home" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/home" className="side-links">
                    {/* <img src={Home} alt="Home" /> */}

                    {/* Svg paths preferred to img src for faster svg rendering */}

                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.2794 5.44624C12.2115 5.3767 12.1211 5.33789 12.0271 5.33789C11.9331 5.33789 11.8427 5.3767 11.7748 5.44624L3.37481 14.0336C3.33914 14.0702 3.31076 14.114 3.29138 14.1626C3.27201 14.2112 3.26205 14.2635 3.26211 14.3164L3.26074 22.3759C3.26074 22.7903 3.41457 23.1878 3.68839 23.4808C3.9622 23.7738 4.33358 23.9384 4.72081 23.9384H9.10558C9.2992 23.9384 9.48489 23.8561 9.6218 23.7096C9.7587 23.5631 9.83562 23.3644 9.83562 23.1572V16.5166C9.83562 16.413 9.87408 16.3136 9.94253 16.2403C10.011 16.1671 10.1038 16.1259 10.2006 16.1259H13.8508C13.9476 16.1259 14.0405 16.1671 14.1089 16.2403C14.1774 16.3136 14.2158 16.413 14.2158 16.5166V23.1572C14.2158 23.3644 14.2927 23.5631 14.4297 23.7096C14.5666 23.8561 14.7522 23.9384 14.9459 23.9384H19.3288C19.716 23.9384 20.0874 23.7738 20.3612 23.4808C20.6351 23.1878 20.7889 22.7903 20.7889 22.3759V14.3164C20.7889 14.2635 20.779 14.2112 20.7596 14.1626C20.7402 14.114 20.7119 14.0702 20.6762 14.0336L12.2794 5.44624Z"
                        fill="#3c3c42"
                      />
                      <path
                        d="M22.744 12.4214L19.3311 8.92725V3.625C19.3311 3.4178 19.2542 3.21909 19.1173 3.07257C18.9804 2.92606 18.7947 2.84375 18.6011 2.84375H16.411C16.2174 2.84375 16.0317 2.92606 15.8948 3.07257C15.7578 3.21909 15.6809 3.4178 15.6809 3.625V5.1875L13.0382 2.4834C12.7909 2.21582 12.4232 2.0625 12.0257 2.0625C11.6297 2.0625 11.2629 2.21582 11.0156 2.48389L1.31065 12.4204C1.02685 12.7134 0.991259 13.1953 1.24951 13.5127C1.31436 13.5928 1.39376 13.658 1.48289 13.7042C1.57202 13.7504 1.669 13.7768 1.76794 13.7816C1.86688 13.7864 1.96571 13.7697 2.05841 13.7324C2.1511 13.695 2.23573 13.6379 2.30715 13.5645L11.7748 3.88281C11.8427 3.81327 11.9331 3.77446 12.0271 3.77446C12.1211 3.77446 12.2115 3.81327 12.2794 3.88281L21.748 13.5645C21.8875 13.7076 22.0743 13.7857 22.2675 13.7817C22.4607 13.7777 22.6445 13.6918 22.7787 13.543C23.0589 13.2324 23.0356 12.7197 22.744 12.4214Z"
                        fill="#3c3c42"
                      />
                    </svg>
                    <p>Home</p>
                  </Link>
                </div>
              )}
              {currentPage === "Home" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/home" className="side-links-a">
                    {/* <img src={HomeA} alt="Home" /> */}
                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.2794 5.44624C12.2115 5.3767 12.1211 5.33789 12.0271 5.33789C11.9331 5.33789 11.8427 5.3767 11.7748 5.44624L3.37481 14.0336C3.33914 14.0702 3.31076 14.114 3.29138 14.1626C3.27201 14.2112 3.26205 14.2635 3.26211 14.3164L3.26074 22.3759C3.26074 22.7903 3.41457 23.1878 3.68839 23.4808C3.9622 23.7738 4.33358 23.9384 4.72081 23.9384H9.10558C9.2992 23.9384 9.48489 23.8561 9.6218 23.7096C9.7587 23.5631 9.83562 23.3644 9.83562 23.1572V16.5166C9.83562 16.413 9.87408 16.3136 9.94253 16.2403C10.011 16.1671 10.1038 16.1259 10.2006 16.1259H13.8508C13.9476 16.1259 14.0405 16.1671 14.1089 16.2403C14.1774 16.3136 14.2158 16.413 14.2158 16.5166V23.1572C14.2158 23.3644 14.2927 23.5631 14.4297 23.7096C14.5666 23.8561 14.7522 23.9384 14.9459 23.9384H19.3288C19.716 23.9384 20.0874 23.7738 20.3612 23.4808C20.6351 23.1878 20.7889 22.7903 20.7889 22.3759V14.3164C20.7889 14.2635 20.779 14.2112 20.7596 14.1626C20.7402 14.114 20.7119 14.0702 20.6762 14.0336L12.2794 5.44624Z"
                        fill="#fff"
                      />
                      <path
                        d="M22.744 12.4214L19.3311 8.92725V3.625C19.3311 3.4178 19.2542 3.21909 19.1173 3.07257C18.9804 2.92606 18.7947 2.84375 18.6011 2.84375H16.411C16.2174 2.84375 16.0317 2.92606 15.8948 3.07257C15.7578 3.21909 15.6809 3.4178 15.6809 3.625V5.1875L13.0382 2.4834C12.7909 2.21582 12.4232 2.0625 12.0257 2.0625C11.6297 2.0625 11.2629 2.21582 11.0156 2.48389L1.31065 12.4204C1.02685 12.7134 0.991259 13.1953 1.24951 13.5127C1.31436 13.5928 1.39376 13.658 1.48289 13.7042C1.57202 13.7504 1.669 13.7768 1.76794 13.7816C1.86688 13.7864 1.96571 13.7697 2.05841 13.7324C2.1511 13.695 2.23573 13.6379 2.30715 13.5645L11.7748 3.88281C11.8427 3.81327 11.9331 3.77446 12.0271 3.77446C12.1211 3.77446 12.2115 3.81327 12.2794 3.88281L21.748 13.5645C21.8875 13.7076 22.0743 13.7857 22.2675 13.7817C22.4607 13.7777 22.6445 13.6918 22.7787 13.543C23.0589 13.2324 23.0356 12.7197 22.744 12.4214Z"
                        fill="#fff"
                      />
                    </svg>
                    <p>Home</p>
                  </Link>
                </div>
              )}
              {currentPage !== "Wallet" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/wallet" className="side-links">
                    {/* <img src={Wallet} alt="Wallet" /> */}
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.70237 5.07723H19.3031C19.4736 5.07714 19.644 5.08872 19.8132 5.1119C19.7558 4.68112 19.6176 4.26724 19.4067 3.89519C19.1959 3.52315 18.9168 3.20066 18.5863 2.94715C18.2558 2.69365 17.8808 2.51439 17.4839 2.42019C17.0869 2.32598 16.6762 2.31878 16.2766 2.39901L4.26891 4.59286H4.25522C3.50149 4.7471 2.83122 5.20346 2.38131 5.86873C3.05915 5.35278 3.87055 5.07608 4.70237 5.07723ZM19.3031 6.24911H4.70237C3.92816 6.25001 3.1859 6.57954 2.63845 7.1654C2.091 7.75125 1.78307 8.54558 1.78223 9.37411V18.7491C1.78307 19.5776 2.091 20.372 2.63845 20.9578C3.1859 21.5437 3.92816 21.8732 4.70237 21.8741H19.3031C20.0773 21.8732 20.8195 21.5437 21.367 20.9578C21.9144 20.372 22.2224 19.5776 22.2232 18.7491V9.37411C22.2224 8.54558 21.9144 7.75125 21.367 7.1654C20.8195 6.57954 20.0773 6.25001 19.3031 6.24911ZM17.1358 15.6241C16.847 15.6241 16.5647 15.5325 16.3246 15.3608C16.0845 15.1891 15.8974 14.9451 15.7868 14.6595C15.6763 14.374 15.6474 14.0599 15.7038 13.7568C15.7601 13.4537 15.8992 13.1753 16.1033 12.9568C16.3075 12.7382 16.5677 12.5894 16.8509 12.5291C17.1342 12.4688 17.4277 12.4998 17.6945 12.618C17.9613 12.7363 18.1893 12.9366 18.3498 13.1935C18.5102 13.4505 18.5958 13.7526 18.5958 14.0616C18.5958 14.476 18.442 14.8734 18.1682 15.1665C17.8944 15.4595 17.523 15.6241 17.1358 15.6241Z"
                        fill="#3c3c42"
                      />
                      <path
                        d="M1.80469 12.6719V7.81348C1.80469 6.75537 2.35221 4.98145 4.25259 4.59717C5.86551 4.27344 7.46246 4.27344 7.46246 4.27344C7.46246 4.27344 8.51188 5.05469 7.64497 5.05469C6.77805 5.05469 6.80086 6.25098 7.64497 6.25098C8.48907 6.25098 7.64497 7.39844 7.64497 7.39844L4.24574 11.5244L1.80469 12.6719Z"
                        fill="#3c3c42"
                      />
                    </svg>
                    <p>Wallet</p>
                  </Link>
                </div>
              )}
              {currentPage === "Wallet" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/wallet" className="side-links-a">
                    {/* <img src={WalletA} alt="Wallet" /> */}
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.70237 5.07723H19.3031C19.4736 5.07714 19.644 5.08872 19.8132 5.1119C19.7558 4.68112 19.6176 4.26724 19.4067 3.89519C19.1959 3.52315 18.9168 3.20066 18.5863 2.94715C18.2558 2.69365 17.8808 2.51439 17.4839 2.42019C17.0869 2.32598 16.6762 2.31878 16.2766 2.39901L4.26891 4.59286H4.25522C3.50149 4.7471 2.83122 5.20346 2.38131 5.86873C3.05915 5.35278 3.87055 5.07608 4.70237 5.07723ZM19.3031 6.24911H4.70237C3.92816 6.25001 3.1859 6.57954 2.63845 7.1654C2.091 7.75125 1.78307 8.54558 1.78223 9.37411V18.7491C1.78307 19.5776 2.091 20.372 2.63845 20.9578C3.1859 21.5437 3.92816 21.8732 4.70237 21.8741H19.3031C20.0773 21.8732 20.8195 21.5437 21.367 20.9578C21.9144 20.372 22.2224 19.5776 22.2232 18.7491V9.37411C22.2224 8.54558 21.9144 7.75125 21.367 7.1654C20.8195 6.57954 20.0773 6.25001 19.3031 6.24911ZM17.1358 15.6241C16.847 15.6241 16.5647 15.5325 16.3246 15.3608C16.0845 15.1891 15.8974 14.9451 15.7868 14.6595C15.6763 14.374 15.6474 14.0599 15.7038 13.7568C15.7601 13.4537 15.8992 13.1753 16.1033 12.9568C16.3075 12.7382 16.5677 12.5894 16.8509 12.5291C17.1342 12.4688 17.4277 12.4998 17.6945 12.618C17.9613 12.7363 18.1893 12.9366 18.3498 13.1935C18.5102 13.4505 18.5958 13.7526 18.5958 14.0616C18.5958 14.476 18.442 14.8734 18.1682 15.1665C17.8944 15.4595 17.523 15.6241 17.1358 15.6241Z"
                        fill="#fff"
                      />
                      <path
                        d="M1.80469 12.6719V7.81348C1.80469 6.75537 2.35221 4.98145 4.25259 4.59717C5.86551 4.27344 7.46246 4.27344 7.46246 4.27344C7.46246 4.27344 8.51188 5.05469 7.64497 5.05469C6.77805 5.05469 6.80086 6.25098 7.64497 6.25098C8.48907 6.25098 7.64497 7.39844 7.64497 7.39844L4.24574 11.5244L1.80469 12.6719Z"
                        fill="#fff"
                      />
                    </svg>

                    <p>Wallet</p>
                  </Link>
                </div>
              )}

              {/* // P2P SIde menu */}
              <div className="sidemenu-links">
                {/* to="/dashboard/p2p"  */}
                <WrappedP2PLink
                  to="/dashboard/p2p"
                  className={`side-links${currentPage === "P2P" ? "-a" : ""} ${
                    currentPage !== "P2P"
                      ? disableP2P
                        ? "disable-temp"
                        : ""
                      : ""
                  }`}
                >
                  {/* <img src={P2PA} alt="P2P" /> */}
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1357 1.5625H6.91526C6.14105 1.5634 5.39879 1.89294 4.85134 2.47879C4.30389 3.06465 3.99596 3.85898 3.99512 4.6875V20.3125C3.99596 21.141 4.30389 21.9354 4.85134 22.5212C5.39879 23.1071 6.14105 23.4366 6.91526 23.4375H17.1357C17.91 23.4366 18.6522 23.1071 19.1997 22.5212C19.7471 21.9354 20.055 21.141 20.0559 20.3125V4.6875C20.055 3.85898 19.7471 3.06465 19.1997 2.47879C18.6522 1.89294 17.91 1.5634 17.1357 1.5625ZM12.0255 14.8438H8.37533C8.18171 14.8438 7.99602 14.7614 7.85911 14.6149C7.72221 14.4684 7.64529 14.2697 7.64529 14.0625C7.64529 13.8553 7.72221 13.6566 7.85911 13.5101C7.99602 13.3636 8.18171 13.2812 8.37533 13.2812H12.0255C12.2191 13.2812 12.4048 13.3636 12.5417 13.5101C12.6786 13.6566 12.7555 13.8553 12.7555 14.0625C12.7555 14.2697 12.6786 14.4684 12.5417 14.6149C12.4048 14.7614 12.2191 14.8438 12.0255 14.8438ZM15.6757 10.9375H8.37533C8.18171 10.9375 7.99602 10.8552 7.85911 10.7087C7.72221 10.5622 7.64529 10.3635 7.64529 10.1562C7.64529 9.94905 7.72221 9.75034 7.85911 9.60382C7.99602 9.45731 8.18171 9.375 8.37533 9.375H15.6757C15.8693 9.375 16.055 9.45731 16.1919 9.60382C16.3288 9.75034 16.4057 9.94905 16.4057 10.1562C16.4057 10.3635 16.3288 10.5622 16.1919 10.7087C16.055 10.8552 15.8693 10.9375 15.6757 10.9375ZM15.6757 7.03125H8.37533C8.18171 7.03125 7.99602 6.94894 7.85911 6.80243C7.72221 6.65591 7.64529 6.4572 7.64529 6.25C7.64529 6.0428 7.72221 5.84409 7.85911 5.69757C7.99602 5.55106 8.18171 5.46875 8.37533 5.46875H15.6757C15.8693 5.46875 16.055 5.55106 16.1919 5.69757C16.3288 5.84409 16.4057 6.0428 16.4057 6.25C16.4057 6.4572 16.3288 6.65591 16.1919 6.80243C16.055 6.94894 15.8693 7.03125 15.6757 7.03125Z"
                      fill={currentPage === "P2P" ? "#fff" : "#3c3c42"}
                    />
                  </svg>
                  <p>P2P</p>
                </WrappedP2PLink>
              </div>
              {/* // SWAP SIde menu */}
              <div className="sidemenu-links">
                <Link
                  to="/dashboard/swap"
                  className={`side-links${
                    currentPage === "Exchange" ? "-a" : ""
                  } ${
                    currentPage !== "P2P"
                      ? disableSwap
                        ? "disable-temp"
                        : ""
                      : ""
                  }`}
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.7619 15.854L20.0558 12.9575C19.9205 12.812 19.7595 12.6966 19.5823 12.6181C19.4051 12.5396 19.215 12.4994 19.0232 12.5H12.7554V10.9375H19.3257C19.713 10.9375 20.0843 10.7729 20.3582 10.4799C20.632 10.1868 20.7858 9.7894 20.7858 9.375V4.6875C20.7858 4.2731 20.632 3.87567 20.3582 3.58265C20.0843 3.28962 19.713 3.125 19.3257 3.125H12.7554V2.34375C12.7554 2.13655 12.6785 1.93784 12.5416 1.79132C12.4047 1.64481 12.219 1.5625 12.0254 1.5625C11.8318 1.5625 11.6461 1.64481 11.5092 1.79132C11.3723 1.93784 11.2953 2.13655 11.2953 2.34375V3.125H5.02754C4.83571 3.12443 4.64569 3.16457 4.46846 3.24311C4.29122 3.32164 4.1303 3.437 3.995 3.58252L1.28885 6.479C1.15204 6.6255 1.0752 6.82414 1.0752 7.03125C1.0752 7.23836 1.15204 7.437 1.28885 7.5835L3.995 10.48C4.1303 10.6255 4.29122 10.7409 4.46846 10.8194C4.64569 10.8979 4.83571 10.9381 5.02754 10.9375H11.2953V12.5H4.72503C4.3378 12.5 3.96642 12.6646 3.69261 12.9576C3.41879 13.2507 3.26496 13.6481 3.26496 14.0625V18.75C3.26496 19.1644 3.41879 19.5618 3.69261 19.8549C3.96642 20.1479 4.3378 20.3125 4.72503 20.3125H11.2953V22.6562C11.2953 22.8635 11.3723 23.0622 11.5092 23.2087C11.6461 23.3552 11.8318 23.4375 12.0254 23.4375C12.219 23.4375 12.4047 23.3552 12.5416 23.2087C12.6785 23.0622 12.7554 22.8635 12.7554 22.6562V20.3125H19.0232C19.215 20.3131 19.4051 20.2729 19.5823 20.1944C19.7595 20.1159 19.9205 20.0005 20.0558 19.855L22.7619 16.9585C22.8987 16.812 22.9756 16.6134 22.9756 16.4062C22.9756 16.1991 22.8987 16.0005 22.7619 15.854Z"
                      fill={currentPage === "Exchange" ? "#fff" : "#3c3c42"}
                    />
                  </svg>
                  <p>Swap</p>
                </Link>
              </div>

              <div className="sidemenu-links">
                {/* to="/dashboard/p2p"  */}
                <WrappedP2PLink
                  to="/dashboard/cards"
                  className={`side-links${currentPage === "Card" ? "-a" : ""}`}
                >
                  <Box
                    mr="0.9em !important"
                    w="24px"
                    fontSize="24px"
                    as={BsFillCreditCard2BackFill}
                    color={currentPage === "Card" ? "#fff" : "#3c3c42"}
                  />
                  <p>Card</p>
                </WrappedP2PLink>
              </div>

              {currentPage !== "Voucher" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/bills" className="side-links ">
                    {/* <div className="side-links "> */}
                    {/* <img src={Account} alt="Account" /> */}
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1357 1.5625H6.91526C6.14105 1.5634 5.39879 1.89294 4.85134 2.47879C4.30389 3.06465 3.99596 3.85898 3.99512 4.6875V20.3125C3.99596 21.141 4.30389 21.9354 4.85134 22.5212C5.39879 23.1071 6.14105 23.4366 6.91526 23.4375H17.1357C17.91 23.4366 18.6522 23.1071 19.1997 22.5212C19.7471 21.9354 20.055 21.141 20.0559 20.3125V4.6875C20.055 3.85898 19.7471 3.06465 19.1997 2.47879C18.6522 1.89294 17.91 1.5634 17.1357 1.5625ZM12.0255 14.8438H8.37533C8.18171 14.8438 7.99602 14.7614 7.85911 14.6149C7.72221 14.4684 7.64529 14.2697 7.64529 14.0625C7.64529 13.8553 7.72221 13.6566 7.85911 13.5101C7.99602 13.3636 8.18171 13.2812 8.37533 13.2812H12.0255C12.2191 13.2812 12.4048 13.3636 12.5417 13.5101C12.6786 13.6566 12.7555 13.8553 12.7555 14.0625C12.7555 14.2697 12.6786 14.4684 12.5417 14.6149C12.4048 14.7614 12.2191 14.8438 12.0255 14.8438ZM15.6757 10.9375H8.37533C8.18171 10.9375 7.99602 10.8552 7.85911 10.7087C7.72221 10.5622 7.64529 10.3635 7.64529 10.1562C7.64529 9.94905 7.72221 9.75034 7.85911 9.60382C7.99602 9.45731 8.18171 9.375 8.37533 9.375H15.6757C15.8693 9.375 16.055 9.45731 16.1919 9.60382C16.3288 9.75034 16.4057 9.94905 16.4057 10.1562C16.4057 10.3635 16.3288 10.5622 16.1919 10.7087C16.055 10.8552 15.8693 10.9375 15.6757 10.9375ZM15.6757 7.03125H8.37533C8.18171 7.03125 7.99602 6.94894 7.85911 6.80243C7.72221 6.65591 7.64529 6.4572 7.64529 6.25C7.64529 6.0428 7.72221 5.84409 7.85911 5.69757C7.99602 5.55106 8.18171 5.46875 8.37533 5.46875H15.6757C15.8693 5.46875 16.055 5.55106 16.1919 5.69757C16.3288 5.84409 16.4057 6.0428 16.4057 6.25C16.4057 6.4572 16.3288 6.65591 16.1919 6.80243C16.055 6.94894 15.8693 7.03125 15.6757 7.03125Z"
                        fill="#3c3c42"
                      />
                    </svg>
                    <p>Bill Payment</p>
                    {/* </div> */}
                  </Link>
                </div>
              )}

              {currentPage === "Voucher" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/bills" className="side-links-a">
                    {/* <img src={AccountA} alt="Account" /> */}
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1357 1.5625H6.91526C6.14105 1.5634 5.39879 1.89294 4.85134 2.47879C4.30389 3.06465 3.99596 3.85898 3.99512 4.6875V20.3125C3.99596 21.141 4.30389 21.9354 4.85134 22.5212C5.39879 23.1071 6.14105 23.4366 6.91526 23.4375H17.1357C17.91 23.4366 18.6522 23.1071 19.1997 22.5212C19.7471 21.9354 20.055 21.141 20.0559 20.3125V4.6875C20.055 3.85898 19.7471 3.06465 19.1997 2.47879C18.6522 1.89294 17.91 1.5634 17.1357 1.5625ZM12.0255 14.8438H8.37533C8.18171 14.8438 7.99602 14.7614 7.85911 14.6149C7.72221 14.4684 7.64529 14.2697 7.64529 14.0625C7.64529 13.8553 7.72221 13.6566 7.85911 13.5101C7.99602 13.3636 8.18171 13.2812 8.37533 13.2812H12.0255C12.2191 13.2812 12.4048 13.3636 12.5417 13.5101C12.6786 13.6566 12.7555 13.8553 12.7555 14.0625C12.7555 14.2697 12.6786 14.4684 12.5417 14.6149C12.4048 14.7614 12.2191 14.8438 12.0255 14.8438ZM15.6757 10.9375H8.37533C8.18171 10.9375 7.99602 10.8552 7.85911 10.7087C7.72221 10.5622 7.64529 10.3635 7.64529 10.1562C7.64529 9.94905 7.72221 9.75034 7.85911 9.60382C7.99602 9.45731 8.18171 9.375 8.37533 9.375H15.6757C15.8693 9.375 16.055 9.45731 16.1919 9.60382C16.3288 9.75034 16.4057 9.94905 16.4057 10.1562C16.4057 10.3635 16.3288 10.5622 16.1919 10.7087C16.055 10.8552 15.8693 10.9375 15.6757 10.9375ZM15.6757 7.03125H8.37533C8.18171 7.03125 7.99602 6.94894 7.85911 6.80243C7.72221 6.65591 7.64529 6.4572 7.64529 6.25C7.64529 6.0428 7.72221 5.84409 7.85911 5.69757C7.99602 5.55106 8.18171 5.46875 8.37533 5.46875H15.6757C15.8693 5.46875 16.055 5.55106 16.1919 5.69757C16.3288 5.84409 16.4057 6.0428 16.4057 6.25C16.4057 6.4572 16.3288 6.65591 16.1919 6.80243C16.055 6.94894 15.8693 7.03125 15.6757 7.03125Z"
                        fill="#fff"
                      />
                    </svg>
                    <p>Bill Payment</p>
                  </Link>
                </div>
              )}

              {/* {currentPage !== "Interest" && (
                <div className="sidemenu-links">
                  <Link
                    to="/dashboard/earn"
                    className="side-links disabled-side-links"
                  >
                    <div className="side-links">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.70237 5.07723H19.3031C19.4736 5.07714 19.644 5.08872 19.8132 5.1119C19.7558 4.68112 19.6176 4.26724 19.4067 3.89519C19.1959 3.52315 18.9168 3.20066 18.5863 2.94715C18.2558 2.69365 17.8808 2.51439 17.4839 2.42019C17.0869 2.32598 16.6762 2.31878 16.2766 2.39901L4.26891 4.59286H4.25522C3.50149 4.7471 2.83122 5.20346 2.38131 5.86873C3.05915 5.35278 3.87055 5.07608 4.70237 5.07723ZM19.3031 6.24911H4.70237C3.92816 6.25001 3.1859 6.57954 2.63845 7.1654C2.091 7.75125 1.78307 8.54558 1.78223 9.37411V18.7491C1.78307 19.5776 2.091 20.372 2.63845 20.9578C3.1859 21.5437 3.92816 21.8732 4.70237 21.8741H19.3031C20.0773 21.8732 20.8195 21.5437 21.367 20.9578C21.9144 20.372 22.2224 19.5776 22.2232 18.7491V9.37411C22.2224 8.54558 21.9144 7.75125 21.367 7.1654C20.8195 6.57954 20.0773 6.25001 19.3031 6.24911ZM17.1358 15.6241C16.847 15.6241 16.5647 15.5325 16.3246 15.3608C16.0845 15.1891 15.8974 14.9451 15.7868 14.6595C15.6763 14.374 15.6474 14.0599 15.7038 13.7568C15.7601 13.4537 15.8992 13.1753 16.1033 12.9568C16.3075 12.7382 16.5677 12.5894 16.8509 12.5291C17.1342 12.4688 17.4277 12.4998 17.6945 12.618C17.9613 12.7363 18.1893 12.9366 18.3498 13.1935C18.5102 13.4505 18.5958 13.7526 18.5958 14.0616C18.5958 14.476 18.442 14.8734 18.1682 15.1665C17.8944 15.4595 17.523 15.6241 17.1358 15.6241Z"
                          fill="#3c3c42"
                        />
                        <path
                          d="M1.80469 12.6719V7.81348C1.80469 6.75537 2.35221 4.98145 4.25259 4.59717C5.86551 4.27344 7.46246 4.27344 7.46246 4.27344C7.46246 4.27344 8.51188 5.05469 7.64497 5.05469C6.77805 5.05469 6.80086 6.25098 7.64497 6.25098C8.48907 6.25098 7.64497 7.39844 7.64497 7.39844L4.24574 11.5244L1.80469 12.6719Z"
                          fill="#3c3c42"
                        />
                      </svg>
                      <p>Earn Interest</p>
                    </div>
                  </Link>
                </div>
              )} */}

              <div className="sidemenu-links">
                <WrappedP2PLink
                  to="/dashboard/earn"
                  className={`side-links${currentPage === "Earn" ? "-a" : ""}`}
                >
                  <Box
                    mr="0.9em !important"
                    w="24px"
                    fontSize="24px"
                    as={EarnWallet}
                    color={currentPage === "Earn" ? "#fff" : "#3c3c42"}
                  />
                  <p>Earn</p>
                </WrappedP2PLink>
              </div>

              {/* {currentPage === "Interest" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/earn" className="side-links-a">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.70237 5.07723H19.3031C19.4736 5.07714 19.644 5.08872 19.8132 5.1119C19.7558 4.68112 19.6176 4.26724 19.4067 3.89519C19.1959 3.52315 18.9168 3.20066 18.5863 2.94715C18.2558 2.69365 17.8808 2.51439 17.4839 2.42019C17.0869 2.32598 16.6762 2.31878 16.2766 2.39901L4.26891 4.59286H4.25522C3.50149 4.7471 2.83122 5.20346 2.38131 5.86873C3.05915 5.35278 3.87055 5.07608 4.70237 5.07723ZM19.3031 6.24911H4.70237C3.92816 6.25001 3.1859 6.57954 2.63845 7.1654C2.091 7.75125 1.78307 8.54558 1.78223 9.37411V18.7491C1.78307 19.5776 2.091 20.372 2.63845 20.9578C3.1859 21.5437 3.92816 21.8732 4.70237 21.8741H19.3031C20.0773 21.8732 20.8195 21.5437 21.367 20.9578C21.9144 20.372 22.2224 19.5776 22.2232 18.7491V9.37411C22.2224 8.54558 21.9144 7.75125 21.367 7.1654C20.8195 6.57954 20.0773 6.25001 19.3031 6.24911ZM17.1358 15.6241C16.847 15.6241 16.5647 15.5325 16.3246 15.3608C16.0845 15.1891 15.8974 14.9451 15.7868 14.6595C15.6763 14.374 15.6474 14.0599 15.7038 13.7568C15.7601 13.4537 15.8992 13.1753 16.1033 12.9568C16.3075 12.7382 16.5677 12.5894 16.8509 12.5291C17.1342 12.4688 17.4277 12.4998 17.6945 12.618C17.9613 12.7363 18.1893 12.9366 18.3498 13.1935C18.5102 13.4505 18.5958 13.7526 18.5958 14.0616C18.5958 14.476 18.442 14.8734 18.1682 15.1665C17.8944 15.4595 17.523 15.6241 17.1358 15.6241Z"
                        fill="#3c3c42"
                      />
                      <path
                        d="M1.80469 12.6719V7.81348C1.80469 6.75537 2.35221 4.98145 4.25259 4.59717C5.86551 4.27344 7.46246 4.27344 7.46246 4.27344C7.46246 4.27344 8.51188 5.05469 7.64497 5.05469C6.77805 5.05469 6.80086 6.25098 7.64497 6.25098C8.48907 6.25098 7.64497 7.39844 7.64497 7.39844L4.24574 11.5244L1.80469 12.6719Z"
                        fill="#3c3c42"
                      />
                    </svg>
                    <p>Earn Interest</p>
                  </Link>
                </div>
              )} */}

              {currentPage === "Account" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/account" className="side-links-a">
                    {/* <img src={AccountA} alt="Account" /> */}
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8072 13.6484L20.7858 13.6299L19.3458 12.4214C19.2546 12.3442 19.1818 12.2449 19.1334 12.1318C19.085 12.0186 19.0624 11.8948 19.0674 11.7705V11.2061C19.0629 11.0825 19.0858 10.9596 19.1342 10.8474C19.1827 10.7352 19.2553 10.6369 19.3462 10.5605L20.7858 9.35156L20.8072 9.33301C21.0292 9.13509 21.1782 8.85911 21.2275 8.55443C21.2768 8.24974 21.2233 7.93622 21.0764 7.66992L19.1277 4.06152C19.1254 4.05812 19.1234 4.05453 19.1217 4.05078C18.9741 3.78817 18.7451 3.58919 18.4747 3.48839C18.2042 3.3876 17.9093 3.39136 17.6411 3.49902L17.6252 3.50537L15.9324 4.23437C15.8256 4.2806 15.71 4.299 15.5952 4.28805C15.4804 4.2771 15.3697 4.23711 15.2722 4.17139C15.1225 4.07048 14.9704 3.9751 14.8159 3.88525C14.7157 3.82711 14.6297 3.74459 14.5648 3.64434C14.4999 3.54409 14.4579 3.42891 14.4422 3.30811L14.1872 1.375L14.1817 1.33984C14.1262 1.04043 13.976 0.770592 13.7565 0.57568C13.537 0.380769 13.2614 0.272664 12.9762 0.269531H9.07418C8.78493 0.270522 8.50529 0.380721 8.28452 0.580715C8.06375 0.780709 7.91601 1.05767 7.86734 1.36279L7.86323 1.39014L7.60909 3.32715C7.5935 3.44761 7.55185 3.56251 7.48745 3.66271C7.42305 3.7629 7.33768 3.84563 7.23814 3.9043C7.08317 3.99362 6.93099 4.0884 6.78187 4.18848C6.68453 4.2538 6.5741 4.29348 6.45964 4.30426C6.34519 4.31504 6.22998 4.29661 6.12347 4.25049L4.42933 3.51807L4.41336 3.51123C4.14483 3.40345 3.84949 3.39983 3.57872 3.501C3.30795 3.60217 3.07889 3.80172 2.93139 4.06494L2.92546 4.07568L0.973986 7.68652C0.826898 7.95309 0.773213 8.26696 0.822532 8.57201C0.871851 8.87705 1.02096 9.15337 1.24319 9.35156L1.26463 9.37012L2.70463 10.5786C2.79582 10.6558 2.86859 10.7551 2.91698 10.8682C2.96536 10.9814 2.98797 11.1052 2.98295 11.2295V11.7939C2.98752 11.9175 2.96463 12.0404 2.91617 12.1526C2.8677 12.2648 2.79505 12.3631 2.70417 12.4395L1.26463 13.6484L1.24319 13.667C1.02118 13.8649 0.872192 14.1409 0.822873 14.4456C0.773555 14.7503 0.827119 15.0638 0.973986 15.3301L2.92272 18.9385C2.92497 18.9419 2.92695 18.9455 2.92865 18.9492C3.07631 19.2118 3.30526 19.4108 3.57573 19.5116C3.84619 19.6124 4.14111 19.6086 4.40926 19.501L4.42523 19.4946L6.11663 18.7656C6.22347 18.7194 6.33904 18.701 6.45383 18.7119C6.56862 18.7229 6.67934 18.7629 6.77685 18.8286C6.92651 18.9298 7.0786 19.0252 7.23312 19.1147C7.33331 19.1729 7.41933 19.2554 7.48424 19.3557C7.54915 19.4559 7.59113 19.5711 7.60681 19.6919L7.8605 21.625L7.86597 21.6602C7.92159 21.9601 8.07213 22.2303 8.29222 22.4252C8.51231 22.6202 8.78848 22.728 9.07418 22.7305H12.9762C13.2655 22.7295 13.5451 22.6193 13.7659 22.4193C13.9866 22.2193 14.1344 21.9423 14.1831 21.6372L14.1872 21.6099L14.4413 19.6729C14.4571 19.5522 14.4991 19.4371 14.5639 19.3369C14.6288 19.2367 14.7146 19.1541 14.8145 19.0957C14.9706 19.0059 15.123 18.9106 15.2708 18.8115C15.3681 18.7462 15.4786 18.7065 15.593 18.6957C15.7075 18.685 15.8227 18.7034 15.9292 18.7495L17.6233 19.4795L17.6393 19.4863C17.9078 19.5943 18.2032 19.598 18.4741 19.4968C18.7449 19.3957 18.9739 19.196 19.1213 18.9326C19.1231 18.9289 19.1251 18.9253 19.1272 18.9219L21.076 15.314C21.2233 15.0474 21.2772 14.7335 21.2279 14.4283C21.1787 14.1231 21.0296 13.8467 20.8072 13.6484ZM14.6713 11.6836C14.638 12.4397 14.4002 13.1693 13.9868 13.7834C13.5733 14.3976 13.002 14.87 12.3423 15.1432C11.6826 15.4163 10.9629 15.4785 10.2708 15.322C9.57875 15.1656 8.94405 14.7974 8.4439 14.2621C7.94376 13.7268 7.59972 13.0475 7.45364 12.3068C7.30755 11.5662 7.36571 10.7961 7.62103 10.0901C7.87635 9.38417 8.31785 8.77283 8.89182 8.33042C9.46579 7.88802 10.1475 7.63361 10.8541 7.59814C11.3614 7.57424 11.8677 7.66356 12.341 7.86043C12.8142 8.05729 13.244 8.35739 13.6031 8.74164C13.9621 9.12589 14.2425 9.58588 14.4264 10.0924C14.6103 10.5988 14.6937 11.1407 14.6713 11.6836Z"
                        fill="white"
                      />
                    </svg>
                    <p>Account</p>
                  </Link>
                </div>
              )}

              {currentPage !== "Account" && (
                <div className="sidemenu-links">
                  <Link to="/dashboard/account" className="side-links">
                    {/* <img src={Account} alt="Account" /> */}
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8072 13.6484L20.7858 13.6299L19.3458 12.4214C19.2546 12.3442 19.1818 12.2449 19.1334 12.1318C19.085 12.0186 19.0624 11.8948 19.0674 11.7705V11.2061C19.0629 11.0825 19.0858 10.9596 19.1342 10.8474C19.1827 10.7352 19.2553 10.6369 19.3462 10.5605L20.7858 9.35156L20.8072 9.33301C21.0292 9.13509 21.1782 8.85911 21.2275 8.55443C21.2768 8.24974 21.2233 7.93622 21.0764 7.66992L19.1277 4.06152C19.1254 4.05812 19.1234 4.05453 19.1217 4.05078C18.9741 3.78817 18.7451 3.58919 18.4747 3.48839C18.2042 3.3876 17.9093 3.39136 17.6411 3.49902L17.6252 3.50537L15.9324 4.23437C15.8256 4.2806 15.71 4.299 15.5952 4.28805C15.4804 4.2771 15.3697 4.23711 15.2722 4.17139C15.1225 4.07048 14.9704 3.9751 14.8159 3.88525C14.7157 3.82711 14.6297 3.74459 14.5648 3.64434C14.4999 3.54409 14.4579 3.42891 14.4422 3.30811L14.1872 1.375L14.1817 1.33984C14.1262 1.04043 13.976 0.770592 13.7565 0.57568C13.537 0.380769 13.2614 0.272664 12.9762 0.269531H9.07418C8.78493 0.270522 8.50529 0.380721 8.28452 0.580715C8.06375 0.780709 7.91601 1.05767 7.86734 1.36279L7.86323 1.39014L7.60909 3.32715C7.5935 3.44761 7.55185 3.56251 7.48745 3.66271C7.42305 3.7629 7.33768 3.84563 7.23814 3.9043C7.08317 3.99362 6.93099 4.0884 6.78187 4.18848C6.68453 4.2538 6.5741 4.29348 6.45964 4.30426C6.34519 4.31504 6.22998 4.29661 6.12347 4.25049L4.42933 3.51807L4.41336 3.51123C4.14483 3.40345 3.84949 3.39983 3.57872 3.501C3.30795 3.60217 3.07889 3.80172 2.93139 4.06494L2.92546 4.07568L0.973986 7.68652C0.826898 7.95309 0.773213 8.26696 0.822532 8.57201C0.871851 8.87705 1.02096 9.15337 1.24319 9.35156L1.26463 9.37012L2.70463 10.5786C2.79582 10.6558 2.86859 10.7551 2.91698 10.8682C2.96536 10.9814 2.98797 11.1052 2.98295 11.2295V11.7939C2.98752 11.9175 2.96463 12.0404 2.91617 12.1526C2.8677 12.2648 2.79505 12.3631 2.70417 12.4395L1.26463 13.6484L1.24319 13.667C1.02118 13.8649 0.872192 14.1409 0.822873 14.4456C0.773555 14.7503 0.827119 15.0638 0.973986 15.3301L2.92272 18.9385C2.92497 18.9419 2.92695 18.9455 2.92865 18.9492C3.07631 19.2118 3.30526 19.4108 3.57573 19.5116C3.84619 19.6124 4.14111 19.6086 4.40926 19.501L4.42523 19.4946L6.11663 18.7656C6.22347 18.7194 6.33904 18.701 6.45383 18.7119C6.56862 18.7229 6.67934 18.7629 6.77685 18.8286C6.92651 18.9298 7.0786 19.0252 7.23312 19.1147C7.33331 19.1729 7.41933 19.2554 7.48424 19.3557C7.54915 19.4559 7.59113 19.5711 7.60681 19.6919L7.8605 21.625L7.86597 21.6602C7.92159 21.9601 8.07213 22.2303 8.29222 22.4252C8.51231 22.6202 8.78848 22.728 9.07418 22.7305H12.9762C13.2655 22.7295 13.5451 22.6193 13.7659 22.4193C13.9866 22.2193 14.1344 21.9423 14.1831 21.6372L14.1872 21.6099L14.4413 19.6729C14.4571 19.5522 14.4991 19.4371 14.5639 19.3369C14.6288 19.2367 14.7146 19.1541 14.8145 19.0957C14.9706 19.0059 15.123 18.9106 15.2708 18.8115C15.3681 18.7462 15.4786 18.7065 15.593 18.6957C15.7075 18.685 15.8227 18.7034 15.9292 18.7495L17.6233 19.4795L17.6393 19.4863C17.9078 19.5943 18.2032 19.598 18.4741 19.4968C18.7449 19.3957 18.9739 19.196 19.1213 18.9326C19.1231 18.9289 19.1251 18.9253 19.1272 18.9219L21.076 15.314C21.2233 15.0474 21.2772 14.7335 21.2279 14.4283C21.1787 14.1231 21.0296 13.8467 20.8072 13.6484ZM14.6713 11.6836C14.638 12.4397 14.4002 13.1693 13.9868 13.7834C13.5733 14.3976 13.002 14.87 12.3423 15.1432C11.6826 15.4163 10.9629 15.4785 10.2708 15.322C9.57875 15.1656 8.94405 14.7974 8.4439 14.2621C7.94376 13.7268 7.59972 13.0475 7.45364 12.3068C7.30755 11.5662 7.36571 10.7961 7.62103 10.0901C7.87635 9.38417 8.31785 8.77283 8.89182 8.33042C9.46579 7.88802 10.1475 7.63361 10.8541 7.59814C11.3614 7.57424 11.8677 7.66356 12.341 7.86043C12.8142 8.05729 13.244 8.35739 13.6031 8.74164C13.9621 9.12589 14.2425 9.58588 14.4264 10.0924C14.6103 10.5988 14.6937 11.1407 14.6713 11.6836Z"
                        fill="#3c3c42"
                      />
                    </svg>
                    <p>Account</p>
                  </Link>
                </div>
              )}

              <button className="sidemenu-links" onClick={openLogout}>
                <div className="side-links">
                  {/* <img src={Logout} alt="Log out" /> */}
                  {/* <HStack mt="0"> */}
                  <Box as={Logout} color="red.500" />
                  <Box as="p" color="red.500" className="red">
                    Log out
                  </Box>
                  {/* </HStack> */}
                </div>
              </button>
            </div>
            <div className="sidemenu-bottom">
              <div className="sidemenu-bottom-content">
                <h2> Download the Bitmama App now</h2>
                <div className="side-download-btns">
                  <Link
                    to={{
                      pathname:
                        "https://play.google.com/store/apps/details?id=com.bitmama.bitmama",
                    }}
                    target="_blank"
                  >
                    <img className="dload-app" src={Google} alt="" />
                  </Link>
                  <Link
                    to={{
                      pathname:
                        "https://apps.apple.com/us/app/bitmama/id1561857024",
                    }}
                    target="_blank"
                  >
                    <img className="dload-app" src={Apple} alt="" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sidemenu-container-m">
          <div className="sidemenu-container-m-content">
            {currentPage !== "Home" && (
              <Link to="/dashboard/home" className="menu-box-m right-m">
                <img src={Bhome} alt="" />
              </Link>
            )}
            {currentPage === "Home" && (
              <Link to="/dashboard/home" className="menu-box-m right-m">
                <img src={BhomeA} alt="" />
              </Link>
            )}
            {currentPage === "Wallet" && (
              <Link to="/dashboard/wallet" className="menu-box-m right-m">
                <img src={BwalletA} alt="" />
              </Link>
            )}
            {currentPage !== "Wallet" && (
              <Link to="/dashboard/wallet" className="menu-box-m right-m">
                <img src={Bwallet} alt="" />
              </Link>
            )}
            {currentPage === "Card" && (
              <Link to="/dashboard/cards" className="menu-box-m right-m">
                <Stack
                  alignItems="center"
                  justifyContent="space-between"
                  minH="42px"
                  color="#02a438"
                >
                  <Box
                    // mr="0.9em !important"
                    w="24px"
                    fontSize="24px"
                    as={BsFillCreditCard2BackFill}
                  />
                  <Text mt="0px !important" fontSize="10px">
                    Card
                  </Text>
                </Stack>
              </Link>
            )}
            {currentPage !== "Card" && (
              <Link to="/dashboard/cards" className="menu-box-m right-m">
                <Stack
                  alignItems="center"
                  justifyContent="space-between"
                  minH="42px"
                  color="#6e7191"
                >
                  <Box
                    // mr="0.9em !important"
                    w="24px"
                    fontSize="24px"
                    as={BsFillCreditCard2BackFill}
                    // color="#fff"
                  />
                  <Text mt="0px !important" fontSize="10px">
                    Card
                  </Text>
                </Stack>
              </Link>
            )}
            {(currentPage !== "P2P" ||
              (currentPage === "P2P" && disableP2P)) && (
              <Link to="/dashboard/p2p" className="menu-box-m right-m ">
                <div className="menu-box-m right-m ">
                  {/* disable-temp */}
                  <img src={Bp2p} alt="" />
                </div>
              </Link>
            )}
            {!disableP2P && currentPage === "P2P" && (
              <Link to="/dashboard/p2p" className="menu-box-m right-m">
                <img src={Bp2pA} alt="" />
              </Link>
            )}
            {!disableSwap && currentPage === "Exchange" && (
              <Link to="/dashboard/swap" className="menu-box-m-a right-m">
                <img src={BswapA} alt="" />
              </Link>
            )}
            {(currentPage !== "Exchange" ||
              (currentPage === "Exchange" && disableP2P)) && (
              <Link to="/dashboard/swap" className="menu-box-m-a right-m">
                <img src={Bswap} alt="" />
              </Link>
            )}
            {currentPage !== "Account" && (
              <Link to="/dashboard/account" className="menu-box-m ">
                <img src={Baccount} alt="" />
              </Link>
            )}
            {currentPage === "Account" && (
              <Link to="/dashboard/account" className="menu-box-m ">
                <img src={BaccountA} alt="" />
              </Link>
            )}
          </div>
        </div>
      </section>

      <Confirm
        isOpen={isOpen}
        onClose={onClose}
        title="Confirm"
        onConfirm={handleLogout}
        buttonText={["Close", "Logout"]}
      >
        <Text textAlign="center">Are you sure you want to logout?</Text>
      </Confirm>
    </div>
  );
};

export default Sidemenu;
